module.exports = __webpack_public_path__ + "media/fonts/MatterSQ-Heavy-725ca4443c8370cdbed367cec106fbea.ttf";